/**
 * ShowingMixin - Shared logic for showing-related components
 *
 * This mixin provides common functionality for components that need to work with
 * showing data, such as seats picker and legend seats components. It handles:
 *
 * - Determining the correct showing ID based on the current context (website, app, kiosk)
 * - Providing reactive showing data to child components
 *
 * Used by: SeatsPicker, LegendSeats, and other showing-dependent components
 */
export default {
  models: {
    showing: {
      movie: 'default',
      screen: 'default',
      showingBadges: true,
      showings: true,
      showing: true,
      variables () {
        return {
          id: this.showingId,
          skip: _.isNil(this.showingId)
        }
      },
      immediate: true,
      force: true
    }
  },
  computed: {
    /**
     * Determines the showing ID from route parameters
     *
     * For kiosk mode: uses 'showing' parameter
     * For other modes: uses 'showingId' parameter
     *
     * @returns {number|null} The showing ID as a number, or null if not available
     */
    showingId () {
      const showingId = this.$kiosk ? this.$route.params?.showing : this.$route.params?.showingId
      return _.isEmpty(showingId) ? null : Number(showingId)
    }
  }
}
